var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionAcknowledgedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.033,
    height: 19.052,
    viewBox: "0 0 19.033 19.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tips_and_updates_FILL1_wght700_GRAD0_opsz48",
    d: "M17.227,5.31l-1.261-.6,1.261-.582.563-1.261.6,1.261,1.242.582-1.242.6-.6,1.242ZM14.472.828l-1.9-.873,1.9-.873L15.326-2.8l.892,1.882L18.1-.045,16.218.828,15.326,2.71ZM6.905,16.252A1.615,1.615,0,0,1,5.664,15.7a1.954,1.954,0,0,1-.5-1.368H8.671A1.913,1.913,0,0,1,8.147,15.7,1.654,1.654,0,0,1,6.905,16.252Zm-2.58-3.24a.665.665,0,0,1-.5-.2.691.691,0,0,1-.194-.495.665.665,0,0,1,.7-.7H9.486a.665.665,0,0,1,.7.7.691.691,0,0,1-.194.495.665.665,0,0,1-.5.2Zm-.6-2.7a7.235,7.235,0,0,1-2.27-2.289A5.772,5.772,0,0,1,.6,4.922,6.075,6.075,0,0,1,2.463.489,6.05,6.05,0,0,1,6.905-1.384,6.059,6.059,0,0,1,11.339.489a6.059,6.059,0,0,1,1.872,4.433,5.822,5.822,0,0,1-.844,3.1,7.071,7.071,0,0,1-2.28,2.289Z",
    transform: "translate(-0.6 2.8)",
    fill: "#62b0dc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionAcknowledgedIcon);
export default __webpack_public_path__ + "static/media/ActionAcknowledgedIcon.1ae54679d1ca5c821fb8b5e3999bfe11.svg";
export { ForwardRef as ReactComponent };